import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
import Button from '../Buttons/Button/Button';
import Select from '../Selectors/Select/Select';
const Container = styled.section `
  ${setCssVar('accentColor', brand.hta.green)};
  ${setCssVar('accentColorAlt', brand.greyVeryLight)};
  ${setCssVar('bgColor', brand.greyVeryLight)};
  ${setCssVar('bgColorAlt', brand.white)};
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('fgColorAlt', brand.black)};

  .theme-rss & {
    ${setCssVar('accentColor', brand.rss.green)};
    ${setCssVar('accentColorAlt', brand.rss.grey)};
    ${setCssVar('bgColor', brand.rss.grey)};
    ${setCssVar('bgColorAlt', brand.white)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  .theme-apl & {
    ${setCssVar('accentColor', brand.apl.green)};
    ${setCssVar('accentColorAlt', brand.apl.green)};
    ${setCssVar('bgColor', brand.greyVeryLight)};
    ${setCssVar('bgColorAlt', brand.white)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.black)};
  }

  color: ${cssVar('fgColor')};
  border-bottom: 6px solid ${cssVar('accentColorAlt')};

  ${({ theme }) => {
    switch (theme) {
        case 'lightGrey':
            return css `
          background: ${cssVar('bgColor')};
          color: ${cssVar('fgColor')};
        `;
        case 'white':
            return css `
          background: ${cssVar('bgColorAlt')};
          color: ${cssVar('fgColorAlt')};
        `;
    }
}}

  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 24px;
  }
`;
const FiltersRow = styled.div `
  display: flex;
  align-items: center;

  ${({ alignment }) => {
    switch (alignment) {
        case 'left':
            return css `
          justify-content: flex-start;
        `;
        case 'center':
            return css `
          justify-content: center;
        `;
        case 'right':
            return css `
          justify-content: flex-end;
        `;
    }
}}

  ${() => Filter}:first-child {
    @media ${from(Device.TabletLarge)} {
      margin-left: 0;
    }
  }
`;
const Title = styled.h3 `
  display: block;
  flex: 0 0 auto;
  ${fonts.sourceSansPro.semiBold};
  font-size: 20px;
  line-height: 28px;

  @media ${from(Device.Desktop)} {
    font-size: 24px;
    line-height: 34px;
  }
`;
const FilterList = styled.div `
  display: flex;
  flex: 1 1 auto;
`;
const Filter = styled.div `
  display: block;
  flex: 1 1 auto;
  margin-left: 16px;
  max-width: 294px;

  @media ${from(Device.Desktop)} {
    margin-left: 30px;
  }
`;
const FilterDropdown = styled(Select) `
  display: block;
  width: 100%;
`;
const CheckboxArea = styled.div `
  display: flex;
  flex-wrap: wrap;
`;
const CheckboxAreaLabel = styled.p `
  ${fonts.sourceSansPro.semiBold};
  font-size: 18px;
  line-height: 34px;
  flex: 1 0 100%;
`;
const FilterHolder = styled.span ``;
const ClearFilter = styled.span `
  display: flex;
  margin: 6px auto -30px;
  width: fit-content;

  button {
    padding: 3px 6px;
    border: 0;
    text-transform: capitalize;

    &:first-of-type {
      background-color: ${brand.greyLight};
    }

    &:last-of-type {
      background-color: ${brand.grey};
      color: ${brand.white};
    }
  }
`;
const SelectedFiltersContainer = styled.div `
  margin-top: 36px;
`;
const SelectedFilters = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;
const SelectedFilterValue = styled(Button) `
  svg {
    width: 10px;
    height: 10px;
  }
`;
const ClearAllSelected = styled(Button) `
  svg {
    width: 10px;
    height: 10px;
  }
`;
const PostcodeSearchButton = styled.button `
  ${ButtonReset}
  display: inline-flex;
  align-items: center;
  border: 1px solid ${cssVar('fgColor')};
  border-radius: 9px;
  color: ${cssVar('fgColor')};
  height: 48px;
  width: 100%;
  position: relative;
  ${fonts.sourceSansPro.regular};
  padding: 0 30px 0 12px;
  font-size: 16px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    line-height: 24px;
  }

  strong {
    ${fonts.sourceSansPro.semiBold};
    margin-right: 4px;
  }

  svg {
    width: 17px;
    color: ${brand.apl.green};
    margin-right: 8px;
  }
`;
export default {
    CheckboxArea,
    CheckboxAreaLabel,
    Container,
    Filter,
    FilterDropdown,
    FilterHolder,
    FilterList,
    FiltersRow,
    Title,
    ClearFilter,
    SelectedFiltersContainer,
    SelectedFilters,
    SelectedFilterValue,
    ClearAllSelected,
    PostcodeSearchButton,
};
